// @flow
import styles from './DidYouMean.less';

import React from 'react';
import { connect } from 'react-redux';

import { didYouMeanClicked } from 'src/store/search/search';
import { TextLink, Text, Hidden } from 'seek-style-guide/react';
import NavLink from 'src/components/NavLink/NavLink';

type Props = {
  locations: SearchViewModelSuggestions,
  onClick: Function
};

function mapDispatchToProps(dispatch) {
  return {
    onClick: () => dispatch(didYouMeanClicked())
  };
}

const DidYouMean = ({ locations, onClick }: Props) => (
  <p className={styles.root} data-automation="didYouMean">
    <Text small raw className={styles.didYouMean}>
      {'Did you mean '}
    </Text>
    <span className={styles.suggestions}>
      {locations.map((location, index) => (
        <span className={styles.locationWrapper} key={index}>
          <NavLink
            component={TextLink}
            className={styles.location}
            location={{
              pathname: '/jobs',
              query: location.refineParams
            }}
            onClick={onClick}
            data-automation={`didYouMeanLocation${index}`}
          >
            <Text small raw>
              {location.label}
            </Text>
          </NavLink>
          {index < locations.length - 1 && (
            <Hidden mobile>
              <Text small raw children=" or " className={styles.or} />
            </Hidden>
          )}
        </span>
      ))}
    </span>
  </p>
);

export default connect(
  null,
  mapDispatchToProps
)(DidYouMean);
